import { HStack, Select } from "@chakra-ui/react";

const TimeSelect = ({ value, onTimeChange, name, isRequired }) => {
  // Generate hour options (0-23)
  const hours = Array.from({ length: 24 }, (_, i) =>
    i.toString().padStart(2, "0")
  );

  // Generate minute options in 15-minute increments
  const minutes = ["00", "15", "30", "45"];

  // Parse current value
  const [currentHour, currentMinute] = value ? value.split(":") : ["", ""];

  const handleTimeChange = (type, newValue) => {
    // // Parse the current value fresh inside the handler
    // const [existingHour, existingMinute] = value ? value.split(":") : ["", ""];

    // const hour = type === "hour" ? newValue : existingHour;
    // const minute = type === "minute" ? newValue : existingMinute;
    // console.log("handling time change", existingHour, existingMinute);

    // if (hour && minute) {
    //   const timeString = `${hour}:${minute}`;
    //   onTimeChange(timeString);
    // }
    const [existingHour, existingMinute] = value ? value.split(":") : ["", ""];

    const hour = type === "hour" ? newValue : existingHour;
    const minute = type === "minute" ? newValue : existingMinute;

    // Always call onTimeChange, even with partial values
    const timeString = `${hour || ""}:${minute || ""}`;
    onTimeChange(timeString);

    console.log("hour:", hour, "minute:", minute);
  };

  return (
    <HStack>
      <Select
        placeholder="Hour"
        value={currentHour}
        onChange={(e) => handleTimeChange("hour", e.target.value)}
        isRequired={isRequired}
      >
        {hours.map((hour) => (
          <option key={hour} value={hour}>
            {hour}
          </option>
        ))}
      </Select>
      <Select
        placeholder="Minutes"
        value={currentMinute}
        onChange={(e) => handleTimeChange("minute", e.target.value)}
        isRequired={isRequired}
      >
        {minutes.map((minute) => (
          <option key={minute} value={minute}>
            {minute}
          </option>
        ))}
      </Select>
    </HStack>
  );
};

export default TimeSelect;
